import { useState } from 'react';
import { Button, Flex, Modal, Steps } from 'antd';
import { BasicInfoStep, AuditTypeStep, QuestionGenerationStep, FormReview } from '.';

export const AuditsCreation = ({ isOpen, onClose }) => {
  const [audit, setAudit] = useState({
    title: '',
    role: '',
    name: '',
    type: '',
    questionGeneration: '',
  });
  const [editQuestions, setEditQuestions] = useState(false);

  const handleValue = (key, value) => {
    setAudit((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const steps = [
    {
      title: 'Basic Information',
      content: <BasicInfoStep audit={audit} handleValue={handleValue} />,
    },
    {
      title: 'Audit Type & Focus',
      content: <AuditTypeStep type={audit.type} handleValue={handleValue} />,
    },
    {
      title: 'Question Generation',
      content: <QuestionGenerationStep questionGeneration={audit.questionGeneration} handleValue={handleValue} />,
    },
  ];

  const [current, setCurrent] = useState(0);
  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    if (!editQuestions) {
      setCurrent(current - 1);
    } else {
      setEditQuestions(false);
    }
  };
  const items = steps.map((item) => ({ key: item.title, title: item.title }));

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      width={700}
      title={!editQuestions ? 'Create New Family Retention Audit' : 'Review Questions'}
      footer={
        <Flex justify="space-between" align="center" style={{ marginTop: 24 }}>
          {current > 0 ? (
            <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
              Previous
            </Button>
          ) : (
            <div />
          )}
          {current < steps.length - 1 && (
            <Button type="primary" onClick={() => next()}>
              Next
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button type="primary" onClick={() => setEditQuestions(true)}>
              Done
            </Button>
          )}
        </Flex>
      }>
      {!editQuestions ? (
        <>
          <Steps current={current} items={items} />
          <div style={{ marginTop: '1rem' }}>{steps[current].content}</div>
        </>
      ) : (
        <FormReview questionGeneration={audit.questionGeneration} handleValue={handleValue} />
      )}
    </Modal>
  );
};
